import { useEffect, useState } from 'react';
import { BiographyService } from "../../services/biographyService";
import { useParams} from "react-router";
import SafeHtmlRenderer from '../../providers/SafeHtmlRender';
import './biography.scss';
import { LoaderSpinner } from '../commons/loaderSpinner/loaderSpinner';

export default function Biography(){

    const params = useParams();
    const lang = params.lang;
    const [pageContent,setPageContent] = useState<any>(null)
    const [pageTitle,setPageTitle] = useState<any>('')
    const biographyService = BiographyService();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLang = async () => {
            const baseSlug = `biography-${lang}`;
            try {
                 setLoading(true);
                if(baseSlug){
                    const res = await biographyService.getPage(baseSlug);
                    setPageTitle(res.data[0].title.rendered);
                    setPageContent(res.data[0].content.rendered);
                }
            } catch (error) {
                console.error("Erreur récupération page", error);
            }finally{
                setLoading(false)
            }
        }
        fetchLang();
    }, [lang]);

    return(
        <>
            {loading ? (
            <LoaderSpinner visible={true} />
            ) : (
            <div className='biography'>
                <h1>{pageTitle}</h1>
                <div className='page-content wp-content'>
                    {pageContent && <SafeHtmlRenderer html={pageContent} />}
                </div>
            </div>
            )}
        </>
    )
}